module.exports = __webpack_public_path__ + "img/dsci0061.f2db919a.jpg";